module.exports = __webpack_public_path__ + "static/media/corporate-services-img5.9e92fbe1.jpg";